<template>
  <div class="card mb-2">
    <div class="card-body bg-secondary pt-2 pb-0 pl-1 pr-2">
      <b-form class="search-form" @submit.prevent="onSearch">
        <div class="d-flex">
          <div class="row align-items-center">
            <div class="input-wrapper" v-if="!excludeSearchFields.includes('related_customer_uuid')">
              <customer-select-input-widget @select="onCustomerSelect"
                                            :model="searchModel"
                                            :label="false" is-search
                                            :options="{placeholder: $t('Related Customer')}"
                                            attribute="related_customer_uuid"/>
            </div>
            <div class="input-wrapper" v-if="!excludeSearchFields.includes('related_to_customer_uuid')">
              <customer-select-input-widget @select="onCustomerSelect"
                                            :model="searchModel"
                                            :label="false" is-search
                                            :options="{placeholder: $t('Related to Customer')}"
                                            attribute="related_to_customer_uuid"/>
            </div>
            <div class="input-wrapper">
              <input-widget :items="customerRelationTypes" value-field="value" display-field="${item.label}"
                            type="select2" :model="searchModel" attribute="type" :label="false"
                            :options="{'placeholder': 'Type'}"/>
            </div>
          </div>
          <div class="search-btn-wrapper">
            <b-button variant="primary" @click.prevent="onResetClick">
              <font-awesome-icon icon="undo" class="icon"/>
              {{ $t('Reset') }}
            </b-button>
            <b-button type="submit" variant="primary" class="ml-2">
              <font-awesome-icon icon="search" class="icon"/>
              {{ $t('Search') }}
            </b-button>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import CustomerSelectInputWidget from "@/core/widgets/CustomerSelectInputWidget";
  import InputWidget from "@/core/components/input-widget/InputWidget";

  const {mapState, mapActions} = createNamespacedHelpers('relations');
  const {mapState: globalMapState} = createNamespacedHelpers('global');

  export default {
    name: "RelationsSearch",
    components: {InputWidget, CustomerSelectInputWidget},
    props: {
      excludeSearchFields: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      ...globalMapState({
        customerRelationTypes: state => state.customerRelationTypes,
      }),
      ...mapState({
        searchModel: state => state.tableData[state.tableSource].searchModel,
        extraFilters: state => state.tableData[state.tableSource].extraFilters,
      }),
    },
    methods: {
      ...mapActions(['getTableData', 'updateSearchModel', 'resetTable', 'resetTableDataPaginationPage']),
      async onSearch() {
        await this.updateSearchModel(this.searchModel);
        this.resetTableDataPaginationPage();
        this.getTableData();
      },
      async onCustomerSelect(customer) {
        this.updateSearchModel({related_customer: customer});
      },
      onResetClick() {
        this.resetTable();
      },
    },
  }
</script>

<style lang="scss" scoped>
</style>
